(() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropSymbols = Object.getOwnPropertySymbols;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __propIsEnum = Object.prototype.propertyIsEnumerable;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols)
      for (var prop of __getOwnPropSymbols(b)) {
        if (__propIsEnum.call(b, prop))
          __defNormalProp(a, prop, b[prop]);
      }
    return a;
  };

  // node_modules/loadx/dist/loadx.module.js
  var n = function() {
    var n2 = {};
    function r(r2, t, e) {
      return new Promise(function(o, u) {
        if (t === null || !(t instanceof HTMLElement))
          return u(new Error("Parent not found."));
        var c = function(r3) {
          var t2 = JSON.stringify(r3), e2 = n2[t2];
          return e2 !== void 0 ? e2 : null;
        }(e);
        if (c !== null)
          return o(c);
        var i = document.createElement(r2);
        i.onload = function() {
          o(i), function(r3, t2) {
            var e2 = JSON.stringify(r3);
            n2[e2] = t2;
          }(e, i);
        }, i.onerror = function(n3) {
          u(new URIError("The asset " + n3.target.src + " didn't load correctly."));
        }, Object.keys(e).forEach(function(n3) {
          i[n3] = e[n3];
        }), t.appendChild(i);
      });
    }
    return r.js = function(n3) {
      return r("script", document.body, { src: n3 });
    }, r.css = function(n3) {
      return r("link", document.head, { type: "text/css", rel: "stylesheet", href: n3 });
    }, r.img = function(n3, t) {
      return r("img", function(n4) {
        return n4 === void 0 ? document.body : n4;
      }(t), { src: n3 });
    }, r;
  }();

  // src/js/helpers/helpers.js
  function getTransitionEndEventName() {
    const transitions = {
      "transition": "transitionend",
      "OTransition": "oTransitionEnd",
      "MozTransition": "transitionend",
      "WebkitTransition": "webkitTransitionEnd"
    };
    let bodyStyle = document.body.style;
    for (let transition in transitions) {
      if (bodyStyle[transition] != void 0) {
        return transitions[transition];
      }
    }
  }

  // src/js/components/navigation.js
  var Navigation = class {
    constructor(_params) {
      this.elements = __spreadValues({}, _params.elements);
      this.nav_group = [], this.states = {
        hamburger: false,
        sticky: false,
        visibility: true
      };
      this.settings = {
        nav: {
          active_class: "is-nav-active",
          sticky_class: "is-sticky",
          hidden_class: "is-hidden",
          current_class: "is-current-page"
        },
        body: {
          active_class: "nav-active"
        }
      };
      this.elements_tree = [];
      this.mobileBreakpoints = ["XXS", "XS", "SM", "MD"];
    }
    static init() {
      const navigation = window.Store.app.theBody.getElementsByClassName("js-navigation")[0];
      if (!navigation)
        return null;
      const primary_nav = navigation.querySelector(".js-primary-nav");
      const navigation_width = navigation.getBoundingClientRect().width;
      const mainNavContainer = navigation.querySelector(".c-navigation__nav__container.is-main-container");
      const inner = navigation.querySelector("nav");
      const inner_scroll = inner.firstElementChild;
      const inner_scroll_padding = getComputedStyle(document.querySelector(":root")).getPropertyValue("--nav-inner-scroll-padding").replace("px", "");
      const hamburger = window.Store.app.theBody.getElementsByClassName("js-hamburger")[0];
      const submenuContainer = window.Store.app.theBody.querySelector(".is-subnav-container");
      const submenuTriggers = window.Store.app.theBody.getElementsByClassName("js-submenu-trigger");
      const submenuElements = window.Store.app.theBody.getElementsByClassName("js-submenu-nav");
      const mobileBackbuttons = window.Store.app.theBody.getElementsByClassName("js-back-button");
      const closeButtons = window.Store.app.theBody.getElementsByClassName("js-close-button");
      let header = window.Store.app.theBody.querySelector(".js-navigation");
      let header_height = window.Store.scrollbar.world.h;
      if (header) {
        header ? header = header : null;
        header_height = header.scrollHeight;
      }
      const params = {
        elements: {
          nav: {
            element: navigation,
            primary_nav,
            height: null,
            width: navigation_width,
            inner: {
              container: mainNavContainer,
              element: inner,
              scroll: inner_scroll,
              scroll_padding: parseInt(inner_scroll_padding),
              height: null
            },
            secondary_nav: {
              is_open: false,
              container: submenuContainer,
              elements: submenuElements,
              triggers: submenuTriggers,
              backButtons: mobileBackbuttons,
              closeButtons
            },
            generic_nav: {
              is_open: false
            }
          },
          hamburger,
          header: {
            element: header,
            height: header_height
          }
        }
      };
      const obj = new Navigation(params);
      obj.hamburgerInit();
      obj.createSubnavDOM();
      obj.addSubmenuEvents();
      obj.createGroups();
      obj.setActiveLink();
      obj.updateNavHeight();
      obj.updateNavInnerScrollHeight();
      obj.handleStickyState();
      return obj;
    }
    hamburgerInit() {
      this.elements.hamburger.addEventListener("click", this.hamburgerToggle.bind(this));
    }
    hamburgerToggle() {
      if (!this.states.hamburger) {
        this.navigationToggle(this.states.hamburger);
        return;
      }
      this.navigationToggle("close");
    }
    addSubmenuEvents() {
      const triggers = this.elements.nav.secondary_nav.triggers;
      const backButtons = this.elements.nav.secondary_nav.backButtons;
      const closeButtons = this.elements.nav.secondary_nav.closeButtons;
      const secondaryNavContainer = this.elements.nav.secondary_nav.container;
      for (let trigger of triggers) {
        trigger.addEventListener("click", (e) => this.submenuTriggerClickHandler(e));
      }
      for (let backButton of backButtons) {
        backButton.addEventListener("click", () => this.closeSubmenu());
      }
      for (let closeButton of closeButtons) {
        closeButton.addEventListener("click", () => this.closeSubmenu());
      }
      secondaryNavContainer.addEventListener(getTransitionEndEventName(), (e) => this.handleSubmenu(e));
    }
    createSubnavDOM() {
      const triggers = this.elements.nav.secondary_nav.triggers;
      for (let trigger of triggers) {
        if (trigger.getAttribute("data-submenu-type") && trigger.getAttribute("data-submenu-type") === "secondary") {
          const data = {
            "title": trigger.innerHTML
          };
          const submenu = this.elements.nav.secondary_nav.container.querySelector(".c-navigation__nav__secondary.is-subnav-template").cloneNode(true);
          submenu.classList.add(trigger.getAttribute("data-submenu"));
          submenu.classList.remove("is-subnav-template");
          submenu.querySelector(".js-nav-title").innerHTML = data.title;
          const subnavElements = trigger.closest("li").querySelectorAll("li.menu-item");
          for (let subnavElement of subnavElements) {
            const element = subnavElement.cloneNode(true);
            element.classList.add("c-navigation__nav__secondary__item");
            element.classList.add("js-nav-list-item");
            element.querySelector("a").classList.add("h4");
            submenu.querySelector(".js-nav-list").appendChild(element);
          }
          this.elements.nav.secondary_nav.container.appendChild(submenu);
        }
      }
    }
    closeSubmenu() {
      var _a;
      const secondaryNav = this.elements.nav.secondary_nav;
      if (!secondaryNav.is_open) {
        if (this.elements.nav.generic_nav.is_open) {
          this.elements.nav.element.querySelector(".is-submenu-trigger.is-active").classList.remove("is-active");
          this.elements.header.element.classList.remove("is-subnav-open");
          this.elements.nav.generic_nav.is_open = false;
        }
        return;
      }
      document.removeEventListener("click", this.closeSubnavEvent);
      let requestedSubmenu = secondaryNav.container.querySelector(".c-navigation__nav__secondary.is-active");
      (_a = this.elements.nav.primary_nav.querySelector("li.is-active")) == null ? void 0 : _a.classList.remove("is-active");
      if (this.mobileBreakpoints.includes(Store.app.activeBreakpoint)) {
        requestedSubmenu == null ? void 0 : requestedSubmenu.classList.remove("is-active");
        this.elements.nav.inner.container.classList.remove("is-inactive");
        this.elements.header.element.classList.remove("is-subnav-open");
        secondaryNav.container.classList.remove("is-active");
        secondaryNav.is_open = false;
      } else {
        secondaryNav.container.style.height = `${requestedSubmenu.scrollHeight}px`;
        setTimeout(() => {
          secondaryNav.container.style.height = "0";
          requestedSubmenu.style.opacity = 0;
        }, 10);
      }
    }
    submenuTriggerClickHandler(e) {
      e.preventDefault();
      e.stopPropagation();
      const secondaryNav = this.elements.nav.secondary_nav;
      const activeGenericSubmenuElement = this.elements.nav.element.querySelector(".is-submenu-trigger.is-active");
      if (e.target.classList.contains("is-generic-submenu-trigger")) {
        if (this.elements.nav.secondary_nav.is_open) {
          this.closeSubmenu();
        }
        if (this.elements.nav.generic_nav.is_open) {
          activeGenericSubmenuElement.classList.remove("is-active");
          this.elements.header.element.classList.remove("is-subnav-open");
          this.elements.nav.generic_nav.is_open = false;
          if (e.target.closest("li") === activeGenericSubmenuElement) {
            return false;
          }
        }
      } else {
        if (this.elements.nav.generic_nav.is_open) {
          activeGenericSubmenuElement.classList.remove("is-active");
          this.elements.header.element.classList.remove("is-subnav-open");
          this.elements.nav.generic_nav.is_open = false;
        }
      }
      this.closeSubnavEvent = (e2) => {
        if (!e2.target.closest("header")) {
          this.closeSubmenu();
        }
      };
      let requestedSubmenu = window.Store.app.theBody.querySelector(`.${e.target.getAttribute("data-submenu")}`);
      document.addEventListener("click", this.closeSubnavEvent);
      if (!requestedSubmenu) {
        requestedSubmenu = window.Store.app.theBody.querySelector(`.${e.target.closest(".js-submenu-trigger").getAttribute("data-submenu")}`);
      }
      if (this.mobileBreakpoints.includes(Store.app.activeBreakpoint)) {
        if (!secondaryNav.is_open) {
          this.elements.nav.inner.container.classList.add("is-inactive");
          this.elements.header.element.classList.add("is-subnav-open");
          secondaryNav.container.classList.add("is-active");
          requestedSubmenu.style.display = "";
          requestedSubmenu.classList.add("is-active");
          secondaryNav.is_open = true;
        }
      } else {
        if (e.target.classList.contains("is-generic-submenu-trigger") || e.target.parentNode.classList.contains("is-generic-submenu-trigger")) {
          e.target.closest(".is-submenu-trigger").classList.add("is-active");
          this.elements.header.element.classList.add("is-subnav-open");
          this.elements.nav.generic_nav.is_open = true;
          return false;
        }
        if (!secondaryNav.is_open) {
          requestedSubmenu.style.display = "";
          let navHeight = `${requestedSubmenu.scrollHeight}px`;
          e.target.closest("li").classList.add("is-active");
          this.elements.header.element.classList.add("is-subnav-open");
          setTimeout(() => {
            if (this.elements.nav.inner.container.offsetHeight + requestedSubmenu.scrollHeight > window.innerHeight) {
              navHeight = `${window.innerHeight - this.elements.nav.inner.container.offsetHeight}px`;
            }
            secondaryNav.container.style.height = navHeight;
            requestedSubmenu.classList.add("is-active");
          }, 10);
        } else {
          this.elements.nav.primary_nav.querySelector("li.is-active").classList.remove("is-active");
          if (!requestedSubmenu.classList.contains("is-active")) {
            const activeSubmenu = secondaryNav.container.querySelector(".c-navigation__nav__secondary.is-active");
            e.target.closest("li").classList.add("is-active");
            secondaryNav.container.style.height = `${activeSubmenu.scrollHeight}px`;
            activeSubmenu.classList.remove("is-active");
            requestedSubmenu.style.display = "";
            secondaryNav.container.style.height = `${requestedSubmenu.scrollHeight}px`;
            setTimeout(() => {
              requestedSubmenu.classList.add("is-active");
            }, 10);
          } else {
            secondaryNav.container.style.height = `${requestedSubmenu.scrollHeight}px`;
            setTimeout(() => {
              secondaryNav.container.style.height = "0";
              requestedSubmenu.style.opacity = 0;
            }, 10);
          }
        }
      }
    }
    handleSubmenu(e) {
      if (e.propertyName !== "height") {
        return;
      }
      const secondaryNav = this.elements.nav.secondary_nav;
      if (secondaryNav.is_open && secondaryNav.container.offsetHeight <= 1) {
        secondaryNav.container.style.height = "";
        secondaryNav.container.style.overflow = "";
        secondaryNav.container.classList.remove("is-active");
        secondaryNav.is_open = false;
        for (let nav of secondaryNav.elements) {
          nav.classList.remove("is-active");
          nav.style.display = "none";
          nav.style.opacity = "";
        }
        if (!this.elements.nav.generic_nav.is_open) {
          this.elements.header.element.classList.remove("is-subnav-open");
        }
      } else if (secondaryNav.is_open) {
        for (let nav of secondaryNav.elements) {
          if (!nav.classList.contains("is-active")) {
            nav.style.display = "none";
          }
        }
        secondaryNav.container.style.height = "";
      } else {
        if (secondaryNav.container.offsetHeight < secondaryNav.container.scrollHeight) {
          secondaryNav.container.style.overflow = "auto";
        } else {
          secondaryNav.container.style.overflow = "";
          secondaryNav.container.style.height = "";
        }
        secondaryNav.container.classList.add("is-active");
        secondaryNav.is_open = true;
      }
    }
    navigationToggle(current_state) {
      this.states.hamburger = !current_state;
      if (current_state) {
        this.closeSubmenu();
        this.elements.nav.inner.container.classList.remove("is-active");
        this.elements.nav.element.classList.remove(this.settings.nav.active_class);
        this.elements.nav.inner.element.style.height = `0px`;
        this.elements.nav.inner.scroll.scrollTo(0, 0);
        this.elements.nav.inner.scroll.style.overflowY = `unset`;
        this.elements.hamburger.classList.remove(this.settings.nav.active_class);
        window.Store.app.theBody.classList.remove(this.settings.body.active_class);
        this.closeSubLevel();
        return;
      }
      this.elements.nav.inner.container.classList.add("is-active");
      this.elements.nav.element.classList.add(this.settings.nav.active_class);
      this.elements.hamburger.classList.add(this.settings.nav.active_class);
      setTimeout(() => {
        window.Store.app.theHtml.classList.add(this.settings.body.active_class);
        window.Store.app.theBody.classList.add(this.settings.body.active_class);
      }, 300);
      this.elements.nav.inner.element.style.height = `${window.Store.scrollbar.screenHeight - this.elements.nav.height}px`;
      this.checkOverflow();
    }
    watch(y) {
      this.checkVisibility(y);
      if (y > 0) {
        this.elements.nav.element.classList.add(this.settings.nav.sticky_class);
        this.states.sticky = true;
        return;
      }
      this.elements.nav.element.classList.remove(this.settings.nav.sticky_class);
      this.states.sticky = !this.states.sticky;
    }
    checkVisibility(y) {
      if (y > this.elements.header.height && window.Store.scrollbar.direction.y > 0 || window.Store.components.mediaModal.obj && window.Store.components.mediaModal.obj.elements.show_modal) {
        this.elements.nav.element.classList.add(this.settings.nav.hidden_class);
        this.states.visibility = false;
        return;
      }
      this.elements.nav.element.classList.remove(this.settings.nav.hidden_class);
      this.states.visibility = true;
    }
    createSubLevel() {
      const first_level_elements = this.elements.nav.primary_nav ? this.elements.nav.primary_nav.children : null;
      let first_level_arr = [];
      for (let i = 0; i < first_level_elements.length; i++) {
        const first_level = first_level_elements[i];
        const sub_list = first_level.querySelector("ul");
        const span = first_level.querySelector("span");
        if (sub_list && span) {
          first_level.classList.add("has-children");
          const sub_list_height = sub_list.scrollHeight;
          const buttonTemplate = () => {
            return `
                        <button type="button" class="js-toggle-button">
                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M24 24H0V0h24v24z" fill="none" opacity=".87"/>
                                <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z"/>
                            </svg>
                        </button>
                    `;
          };
          const arrowTemplate = () => {
            return `
                        <div class="-navSubArrow">
                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M24 24H0V0h24v24z" fill="none" opacity=".87"/>
                                <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z"/>
                            </svg>
                        </div>
                    `;
          };
          span.insertAdjacentHTML("beforeend", buttonTemplate());
          span.insertAdjacentHTML("beforeend", arrowTemplate());
          const button = first_level.querySelector(".js-toggle-button");
          const obj_first_level = {
            li: first_level,
            button,
            element: sub_list,
            height: sub_list_height,
            group: "first_level",
            depth: 1,
            state: {
              open: false
            },
            settings: {
              active_class: "is-open"
            }
          };
          first_level_arr.push(obj_first_level);
        }
      }
      ;
      this.elements_tree = [...first_level_arr];
    }
    subLevelToggle() {
      this.elements_tree.forEach((item) => {
        item.button.addEventListener("click", () => {
          if (window.Store.scrollbar.world.w < 1200) {
            item.height = item.element.scrollHeight;
            if (!item.state.open) {
              item.li.classList.add(item.settings.active_class);
              item.element.style.height = `${item.height}px`;
              item.state.open = true;
              this.closeSubLevel(item);
              this.checkOverflow(item.height);
              return;
            }
            item.li.classList.remove(item.settings.active_class);
            item.element.style.height = `0px`;
            item.state.open = false;
            this.checkOverflow();
          }
        });
        setTimeout(function() {
          if (item.depth == 1) {
            item.height = item.element.scrollHeight;
            item.li.addEventListener("mouseenter", () => {
              if (window.Store.scrollbar.world.w > 1199) {
                const nav_height = window.Store.components.navigation.obj.elements.nav.element.getBoundingClientRect().height;
                const max_height = window.Store.scrollbar.screenHeight - nav_height;
                item.element.style.height = `${item.height}px`;
                item.element.style.maxHeight = `${max_height}px`;
                if (item.height > max_height) {
                  item.element.style.overflowY = `auto`;
                }
                item.state.open = true;
              }
            });
            item.li.addEventListener("mouseleave", () => {
              if (window.Store.scrollbar.world.w > 1199) {
                item.element.style.height = `0px`;
                item.element.style.maxHeight = `0px`;
                item.element.scrollTo(0, 0);
                item.element.style.overflowY = `unset`;
                item.state.open = false;
              }
            });
          }
        }, window.Store.app.firstLoadDelay);
      });
    }
    closeSubLevel(element) {
      if (!element) {
        this.elements_tree.forEach((item) => {
          if (window.Store.scrollbar.world.w < 1200) {
            if (item.state.open) {
              item.li.classList.remove(item.settings.active_class);
              item.element.style.height = `0px`;
              item.state.open = false;
            }
            return;
          }
          item.li.classList.remove(item.settings.active_class);
          item.state.open = false;
          if (item.depth == 1) {
            item.element.style.height = `0px`;
            return;
          }
          item.element.style.height = `auto`;
          return;
        });
      }
      if (element) {
        const received_element = element;
        const clicked_group = element.group;
        this.elements_tree.forEach((item) => {
          if (item != received_element) {
            const state = item.state.open;
            const group = item.group;
            const active_class = item.settings.active_class;
            if (state && clicked_group && clicked_group == group) {
              item.li.classList.remove(active_class);
              item.element.style.height = `0px`;
              item.state.open = false;
            }
          }
        });
      }
    }
    checkOverflow(item_height = 0) {
      if (this.elements.nav.inner.height + item_height > window.Store.scrollbar.screenHeight - this.elements.nav.height) {
        this.elements.nav.inner.scroll.style.overflowY = `auto`;
        return;
      }
      this.elements.nav.inner.scroll.style.overflowY = `unset`;
    }
    createGroups() {
      const raw_nav_groups = this.elements.nav.element.querySelectorAll("ul");
      raw_nav_groups.forEach((raw_nav_group) => {
        const raw_nav_group_items = raw_nav_group.children;
        let elements = [];
        for (let i = 0; i < raw_nav_group_items.length; i++) {
          const raw_nav_group_item = raw_nav_group_items[i];
          let raw_nav_group_item_link = raw_nav_group_item.querySelector("a");
          raw_nav_group_item_link = (raw_nav_group_item_link == null ? void 0 : raw_nav_group_item_link.target) ? null : raw_nav_group_item_link;
          if (raw_nav_group_item_link) {
            const absolute_url = raw_nav_group_item_link.href;
            const url_object = new URL(absolute_url);
            const url_pathname = url_object.pathname;
            const url_pathname_parsed = url_pathname.replace(/\\|\//g, "");
            const sub_nav = raw_nav_group_item.querySelector("ul");
            const element = {
              item: raw_nav_group_item,
              link: raw_nav_group_item_link,
              url_object,
              url_pathname_parsed,
              sub_nav,
              states: {
                active: false,
                current: false
              }
            };
            elements.push(element);
          }
        }
        const obj = {
          group: raw_nav_group,
          elements
        };
        this.nav_group.push(obj);
      });
    }
    setActiveLink() {
      this.nav_group.forEach((group) => {
        group.elements.forEach((element) => {
          element.states.current = false;
          element.item.classList.remove(this.settings.nav.current_class);
        });
      });
      const current_url = window.location.pathname;
      const current_url_parsed = current_url.replace(/\\|\//g, "");
      this.nav_group.forEach((group) => {
        group.elements.forEach((element) => {
          if (current_url_parsed) {
            const match = current_url_parsed === element.url_pathname_parsed;
            if (match) {
              element.item.classList.add(this.settings.nav.current_class);
              element.states.current = true;
            }
          }
        });
      });
    }
    updateSublevelHeight() {
      this.elements_tree.forEach((item) => {
        if (window.Store.scrollbar.world.w < 1200) {
          if (item.state.open) {
            item.element.style.height = `auto`;
            item.height = item.element.scrollHeight;
            item.element.style.height = `${item.height}px`;
            return;
          }
          item.height = item.element.scrollHeight;
          item.element.style.height = `0px`;
          return;
        }
        if (window.Store.scrollbar.world.w > 1199) {
          if (item.depth == 1) {
            item.element.style.height = `auto`;
            item.element.style.maxHeight = `none`;
            const max_height = window.Store.scrollbar.world.h - this.navHeight;
            item.height = item.element.scrollHeight;
            if (item.height > max_height) {
              item.element.style.overflowY = `auto`;
              return;
            }
            item.element.style.overflowY = `unset`;
          }
        }
      });
    }
    updateNavHeight() {
      const self = this;
      if (!this.elements.nav.height) {
        this.elements.nav.height = this.elements.nav.element.getBoundingClientRect().height;
      }
      self.elements.nav.element.addEventListener(getTransitionEndEventName(), function _listener() {
        self.elements.nav.height = self.elements.nav.element.getBoundingClientRect().height;
        self.elements.nav.element.removeEventListener(getTransitionEndEventName(), _listener, true);
      }, true);
    }
    updateNavInnerScrollHeight() {
      this.elements.nav.inner.height = this.elements.nav.inner.scroll.scrollHeight;
    }
    updateScrollPadding() {
      this.elements.nav.inner.scroll_padding = parseInt(getComputedStyle(document.querySelector(":root")).getPropertyValue("--nav-inner-scroll-padding").replace("px", ""));
    }
    updateNavInnerHeight() {
      if (window.Store.scrollbar.world.w < 1200) {
        if (this.states.hamburger) {
          this.elements.nav.inner.element.style.height = `${window.Store.scrollbar.screenHeight - this.elements.nav.height}px`;
          this.checkOverflow();
          return;
        }
        this.elements.nav.inner.element.style.height = `0px`;
        this.elements.nav.inner.scroll.style.overflowY = `unset`;
        return;
      }
      this.elements.nav.inner.element.style.height = `auto`;
      this.elements.nav.inner.scroll.style.overflowY = `unset`;
    }
    updateNavWidth() {
      this.elements.nav.width = this.elements.nav.element.getBoundingClientRect().width;
    }
    handleStickyState() {
      const spacerInDom = window.Store.app.theContainer.querySelector(":scope > .m-spacer");
      if (spacerInDom) {
        this.elements.nav.element.classList.add("is-alternate-form");
      } else {
        this.elements.nav.element.classList.remove("is-alternate-form");
      }
    }
    globalUpdateNavAndElements() {
      this.updateNavHeight();
      this.updateNavInnerScrollHeight();
      this.updateScrollPadding();
      this.updateNavInnerHeight();
      this.updateNavWidth();
      this.updateSublevelHeight();
    }
    get navHeight() {
      return this.elements.nav.height;
    }
    get navWidth() {
      return this.elements.nav.width;
    }
  };
  function render() {
    window.Store.components.navigation.obj = Navigation.init();
  }
  window.Store.components.navigation.render = render;
})();
